module.exports = "<div class=\"card\">\n  <div class=\"card-block\">\n    <div class=\"card-title\">\n      {{ (currentUser$ | async).email }}\n    </div>\n  </div>\n  <div class=\"card-footer\">\n      <button\n          class=\"btn btn-danger\"\n          (click)=\"logout()\">ログアウト</button>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/shwld/project/shwld/home-counter/app_src/src/app/pages/profile/profile.component.html
// module id = ../../../../../src/app/pages/profile/profile.component.html
// module chunks = main